import { call, put, takeEvery } from "redux-saga/effects";
import { addNewLessonPlanFailed, addNewLessonPlanSuccess, getAdminLesssonPlanFailed, getAdminLesssonPlanSuccess, getStudLessonPlanFailed, getStudLessonPlanSuccess, getTeacherLessonPlanFailed, getTeacherLessonPlanSuccess, updateLessonPlanFailed, updateLessonPlanSuccess } from "./Actions";
import { addNewLessonPlanApi, getAdminLessonPlanApi, getStudLessonPlanApi, getTeacherLessonPlanApi, updateLessonPlanApi } from "./API";
import { ADD_NEW_LESSONPLAN, GET_ADMIN_LESSONPLAN, GET_STUD_LESSONPLAN, GET_TEACHER_LESSONPLAN, UPDATE_LESSONPLAN } from "./Constants";

function* getTeacherLessonPlanAsync() {
    try {
        const response = yield call(getTeacherLessonPlanApi)
        if (response) {
            yield put(getTeacherLessonPlanSuccess(response?.data?.data))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("teacher lesson plan error", error)
        yield put(getTeacherLessonPlanFailed(error?.response?.data?.error || "Unable to Lesson Plan, please try again"))
    }
}

function* addNewLessonPlanAsync(payload) {
    try {
        const response = yield call(addNewLessonPlanApi, payload.payload)
        if (response) {
            yield put(addNewLessonPlanSuccess(response?.data?.data))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("add teacher lesson plan error", error)
        yield put(addNewLessonPlanFailed(error?.response?.data?.error || "Unable to Add Lesson Plan, please try again"))
    }
}


function* updateLessonPlanAsync(payload) {
    try {
        const response = yield call(updateLessonPlanApi, payload.payload)
        if (response) {
            yield put(updateLessonPlanSuccess(response?.data?.data?.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("add teacher lesson plan error", error)
        yield put(updateLessonPlanFailed(error?.response?.data?.error || "Unable to Add Lesson Plan, please try again"))
    }
}

function* getStudLessonPlanAsync(payload) {
    try {
        const response = yield call(getStudLessonPlanApi, payload.payload)
        if (response) {
            yield put(getStudLessonPlanSuccess(Array.isArray(response?.data?.data) ? response?.data?.data : []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("Student lesson plan error", error)
        yield put(getStudLessonPlanFailed(error?.response?.data?.error || "Unable to Lesson Plan, please try again"))
    }
}



function* getAdminLessonPlanAsync() {
    try {
        const response = yield call(getAdminLessonPlanApi)
        if (response) {
            yield put(getAdminLesssonPlanSuccess(Array.isArray(response?.data?.data) ? response?.data?.data : []))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("Student lesson plan error", error)
        yield put(getAdminLesssonPlanFailed(error?.response?.data?.error || "Unable to Get Lesson Plan, please try again"))
    }
}


function* ClassworkSaga() {

    yield takeEvery(GET_TEACHER_LESSONPLAN, getTeacherLessonPlanAsync)
    yield takeEvery(ADD_NEW_LESSONPLAN, addNewLessonPlanAsync)
    yield takeEvery(UPDATE_LESSONPLAN, updateLessonPlanAsync)
    yield takeEvery(GET_STUD_LESSONPLAN, getStudLessonPlanAsync)
    yield takeEvery(GET_ADMIN_LESSONPLAN, getAdminLessonPlanAsync)
  
}







export default ClassworkSaga;